/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
import validator from 'validator'
import AuthService from './AuthService'
import { candidateQuestionAnswerStep, formatStep } from './generateForm'
import { app } from './feathers'
const Auth = new AuthService()

/**
 *
 * @param sentence
 * @param _this
 * @returns {*}
 */
export const replaceVariableInStep = (sentence, _this) => {
  const { rawVariablesById, formData } = _this.state

  // Old replacement with dynamic variables
  for (const id in rawVariablesById) {
    const regex = new RegExp(
      `@\\[[A-zÀ-ú0-9 !?-_,;]+\\]\\(${id.substring(4)}\\)`,
      'g',
    )
    sentence = sentence.replace(regex, rawVariablesById[id].values)
  }

  sentence = sentence.replace(
    '@[Prénom](firstname)',
    formData['Prénom']
      ? formData['Prénom'].charAt(0).toUpperCase() + formData['Prénom'].slice(1)
      : '',
  )
  sentence = sentence.replace(
    '@[Nom](lastname)',
    formData.Nom
      ? formData.Nom.charAt(0).toUpperCase() + formData.Nom.slice(1)
      : '',
  )

  sentence = sentence.replace(
    '@[Mail](email)',
    formData.Mail ? formData.Mail : '',
  )
  sentence = sentence.replace('@[Offre](offerName)', _this.props.offerName)

  sentence = sentence.replace(
    '@Prénom',
    formData['Prénom']
      ? formData['Prénom'].charAt(0).toUpperCase() + formData['Prénom'].slice(1)
      : '',
  )
  sentence = sentence.replace(
    '@Nom',
    formData.Nom
      ? formData.Nom.charAt(0).toUpperCase() + formData.Nom.slice(1)
      : '',
  )
  sentence = sentence.replace('@Mail', formData.Mail ? formData.Mail : '')

  sentence = sentence.replace(
    '@firstname',
    formData['Prénom']
      ? formData['Prénom'].charAt(0).toUpperCase() + formData['Prénom'].slice(1)
      : '',
  )
  sentence = sentence.replace(
    '@name',
    formData.Nom
      ? formData.Nom.charAt(0).toUpperCase() + formData.Nom.slice(1)
      : '',
  )
  sentence = sentence.replace('@email', formData.Mail ? formData.Mail : '')

  return sentence
}

/**
 *
 * @param _this
 * @returns {*}
 */
export const addNextSteps = (_this) => {
  let nextStepIndex
  let nextStep

  for (
    let i = _this.state.currentStepIndex + 1;
    i < _this.state.rawSteps.length;
    i++
  ) {
    nextStepIndex = i
    nextStep = _this.state.rawSteps[nextStepIndex]

    if (
      nextStep.condition !== undefined &&
      nextStep.condition.step_id !== undefined
    ) {
      if (
        nextStep.condition.values === undefined ||
        nextStep.condition.values.length <= 0
      ) {
        continue
      }

      const neededValues = nextStep.condition.values
      const currentValue =
        _this.state.rawVariablesById[`var-${nextStep.condition.step_id}`] &&
        _this.state.rawVariablesById[`var-${nextStep.condition.step_id}`]
          .values_id

      if (currentValue === undefined) {
        continue
      }
      if (neededValues.indexOf(currentValue) < 0) {
        continue
      }
      break
    } else {
      break
    }
  }

  for (let i = nextStepIndex; i < _this.state.rawSteps.length; i++) {
    nextStepIndex = i
    nextStep = _this.state.rawSteps[nextStepIndex]

    if (nextStep.type === 'text') {
      if (
        nextStep.condition !== undefined &&
        nextStep.condition.step_id !== undefined
      ) {
        if (
          nextStep.condition.values === undefined ||
          nextStep.condition.values.length <= 0
        ) {
          continue
        }

        const neededValues = nextStep.condition.values
        const currentValue =
          _this.state.rawVariablesById[`var-${nextStep.condition.step_id}`] &&
          _this.state.rawVariablesById[`var-${nextStep.condition.step_id}`]
            .values_id

        if (currentValue === undefined) {
          continue
        }
        if (neededValues.indexOf(currentValue) < 0) {
          continue
        }

        nextStep.sentence = replaceVariableInStep(nextStep.sentence, _this)
        _this.cf.addRobotChatResponse(nextStep.sentence)

        if (nextStep.endChat) {
          return _this.cf.flowManager.stop()
        }
        continue
      } else {
        nextStep.sentence = replaceVariableInStep(nextStep.sentence, _this)
        _this.cf.addRobotChatResponse(nextStep.sentence)

        if (nextStep.endChat) {
          return _this.cf.flowManager.stop()
        }
        continue
      }
    } else if (
      nextStep.condition !== undefined &&
      nextStep.condition.step_id !== undefined
    ) {
      if (
        nextStep.condition.values === undefined ||
        nextStep.condition.values.length <= 0
      ) {
        continue
      }
      const neededValues = nextStep.condition.values
      const currentValue =
        _this.state.rawVariablesById[`var-${nextStep.condition.step_id}`] &&
        _this.state.rawVariablesById[`var-${nextStep.condition.step_id}`]
          .values_id

      if (currentValue === undefined) {
        continue
      }
      if (neededValues.indexOf(currentValue) < 0) {
        continue
      }
      nextStep.sentence = replaceVariableInStep(nextStep.sentence, _this)
      const newStep = formatStep(nextStep, _this.state.rawSteps)
      _this.cf.addTags([newStep])
      break
    } else {
      nextStep.sentence = replaceVariableInStep(nextStep.sentence, _this)
      const newStep = formatStep(nextStep, _this.state.rawSteps)
      _this.cf.addTags([newStep])
      break
    }
  }

  let hideInputWrapper = false
  let fileInput = false

  if (
    (nextStep.type === 'qcm' && nextStep.options.length <= 8) ||
    nextStep.type === 'video' ||
    nextStep.type === 'show_offers'
  ) {
    hideInputWrapper = true
  }
  if (nextStep.type === 'attachment') {
    fileInput = true
  }

  _this.setState({
    currentStepIndex: nextStepIndex,
    hideInputWrapper,
    fileInput,
  })
}

/**
 *
 * @param selectedPlatform
 * @param _this
 * @param success
 * @param error
 */
export const handleMessagingPlatform = (
  selectedPlatform,
  _this,
  success,
  error,
) => {
  if (selectedPlatform === 'messenger') {
    _this.toggleMessenger(success, error)
  } else if (selectedPlatform === 'sms') {
    addNextSteps(_this)
    success()
  } else {
    success()
  }
}

/**
 *
 * @param number
 * @param _this
 * @param success
 * @param error
 */
export const handleVideo = (stepId, _this, success, error) => {
  const index = _this.state.rawSteps.map((e) => e._id).indexOf(stepId)
  if (index >= 0) {
    const step = _this.state.rawSteps[index]
    _this.toggleVideoPlayer(step.videoUrl, success, error)
  } else {
    error()
  }
}

/**
 *
 * @param number
 * @param _this
 * @param success
 * @param error
 */
export const handleAddPhoneNumber = (number, params, _this, success, error) => {
  const regex = /^\+(?:[0-9] ?){6,14}[0-9]$/

  if (regex.test(number)) {
    Auth.fetch('/lambda-interaction', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...params,
        conversationId: _this.state.conversationId,
        candidateId: _this.props.candidateId,
        phoneNumber: number.substring(1),
      }),
    })
      .then((interaction) => {
        addNextSteps(_this)
        success()
      })
      .catch((err) => {
        console.error(err)
        error()
      })
  } else {
    error()
  }
}

/**
 *
 * @param data
 * @returns {[{text: *, type: string, step_id: *}]|*[]}
 */
export const formatMessage = (data) => {
  if (['checkCandidate', 'messagingPlatform'].includes(data.tag.id)) {
    return []
  }

  const messages = [
    {
      type: 'bot',
      text: data.tag.question,
      step_id: data.tag.id,
    },
  ]

  if (data.tag.type === 'file') {
    messages.push({
      type: 'candidate',
      text: data.tag.domElement.files[0].name,
      step_id: data.tag.id,
    })
  } else if (data.tag.type === 'select' || data.tag.type === 'date') {
    messages.push({
      type: 'candidate',
      text: data.text,
      step_id: data.tag.id,
    })
  } else {
    messages.push({
      type: 'candidate',
      text: data.tag.value,
      step_id: data.tag.id,
    })
  }

  return messages
}

/**
 *
 * @param data
 * @param steps
 * @returns {{values: *, name: *}|{values_id: *, values: *, name: *}}
 */
export const formatVariable = (data, steps) => {
  const stepIndex = steps.map((step) => step._id).indexOf(data.tag.id)
  const step = steps[stepIndex]

  if (data.tag.type === 'date') {
    return {
      name: step.name,
      values: data.date,
      ...(step.requirement_id ? { requirement_id: step.requirement_id } : {}),
    }
  }
  if (data.tag.type === 'select') {
    return {
      name: step.name,
      values: data.text,
      values_id: data.tag.value[0],
      ...(step.requirement_id ? { requirement_id: step.requirement_id } : {}),
    }
  }
  if (data.tag.type === 'text' && step.type === 'qcm') {
    const index = step.options.map((e) => e.label).indexOf(data.text)

    return {
      name: step.name,
      values: data.text,
      values_id: step.options[index].value,
      ...(step.requirement_id ? { requirement_id: step.requirement_id } : {}),
    }
  }
  return {
    name: step.name,
    values: data.tag.value,
    ...(step.requirement_id ? { requirement_id: step.requirement_id } : {}),
  }
}

/**
 *
 * @param data
 * @param steps
 * @returns {*}
 */
export const formatFormData = (data, steps) => {
  Object.keys(data).forEach((id) => {
    const stepIndex = steps.map((step) => step._id).indexOf(id)
    const step = steps[stepIndex]

    data[step.name] = data[id]
  })

  return data
}

/**
 *
 * @param file
 * @returns {boolean}
 */
export const checkFileSize = (file) => {
  const fileSize = file.size / 1024 / 1024 // in MB

  if (fileSize > 5) {
    return false
  }

  return true
}

/**
 *
 * @param date
 * @returns {Promise<*>}
 */
export const handleDate = async (date, pastValueAllowed = false) =>
  Auth.fetch('/lambda-process-date', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      date,
      pastValueAllowed,
    }),
  })
    .then((date) => ({
      status: true,
      value: date,
    }))
    .catch((err) => {
      console.error(err)
      return { status: false }
    })

/**
 *
 * @param file
 * @param stepName
 * @param isResume
 * @param stepId
 * @param conversationId
 * @returns {*}
 */
export const handleFile = async (
  file,
  stepName,
  fileType,
  stepId,
  conversationId,
) => {
  const formData = new FormData()
  formData.append('uri', file)
  formData.append('name', stepName)
  formData.append('stepId', stepId)
  formData.append('type', fileType)
  formData.append('conversationId', conversationId)

  return Auth.fetch('/lambda-candidate-file', {
    method: 'POST',
    body: formData,
  })
}

/**
 *
 * @param text
 * @param _this
 * @param success
 * @returns {Promise<*>}
 */
export const handleCandidateQuestion = async (text, _this, success) => {
  await _this.setState({
    rawSteps: [
      ..._this.state.rawSteps,
      candidateQuestionAnswerStep(
        _this.props.sentences.candidateQuestionAnswer,
      ),
    ],
  })

  if (_this.props.preview) {
    addNextSteps(_this)
    return success()
  }

  Auth.fetch('/lambda-interaction', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      candidateMessage: text,
      candidateId: _this.props.candidateId,
      conversationId: _this.state.conversationId,
    }),
  })
    .then(() => {
      addNextSteps(_this)
      success()
    })
    .catch((err) => {
      console.error(err)
      addNextSteps(_this)
      success()
    })
}

/**
 *
 *
 *
 * @param dto
 * @param success
 * @param error
 * @returns {Promise<void|*>}
 */
export default async function (dto, success, error) {
  try {
    const { conversationId } = this.state
    const stepId = dto.tag.id
    const { type } = dto.tag

    const stepIndex = this.state.rawSteps
      .map((step) => step._id)
      .indexOf(stepId)

    const step = this.state.rawSteps[stepIndex]

    if (step.type === 'qcm' && step.options.length > 8) {
      const { text } = dto
      if (step.options.map((e) => e.label).indexOf(text) < 0) {
        return error('Sélectionnez une réponse de la liste')
      }
    }

    if (dto.tag.type === 'mail' && !validator.isEmail(dto.tag.value)) {
      return error(
        this.props.sentences.invalidMail || 'Entrez une adresse mail valide',
      )
    }

    if (dto.tag.type === 'date') {
      const date = await handleDate(dto.text)

      const { status, message, value } = date

      if (!status) {
        return error(
          message ||
            this.props.sentences.invalidDate ||
            'Indiquez une date précise dans le futur',
        )
      }
      dto.date = value
    }

    if (dto.tag.id === 'candidateQuestion') {
      await handleCandidateQuestion(dto.text, this, success)
      return
    }

    if (dto.tag.type === 'select' && dto.tag?.value[0] === 'playVideo') {
      return handleVideo(dto.tag.id, this, success, error)
    }

    await this.setState({
      formData: formatFormData(this.cf.getFormData(true), this.state.rawSteps),
      messagesToSave: [...this.state.messagesToSave, ...formatMessage(dto)],
      rawVariablesById: {
        ...this.state.rawVariablesById,
        ...{
          [`var-${dto.tag.id}`]: formatVariable(dto, this.state.rawSteps),
        },
      },
      newRawVariablesById: {
        ...this.state.newRawVariablesById,
        ...{
          [`var-${dto.tag.id}`]: formatVariable(dto, this.state.rawSteps),
        },
      },
    })

    if (this.props.preview) {
      addNextSteps(this)
      return success()
    }

    const params = {
      messages: this.state.messagesToSave,
      variablesById: this.state.newRawVariablesById,
      lastStepId: !['checkCandidate', 'messagingPlatform'].includes(dto.tag.id)
        ? dto.tag.id
        : null,
    }

    if (!this.state.candidateAuthenticated) {
      // If candidate is the same that the one stored in jwt, add infos from jwt to state
      if (dto.tag.id === 'checkCandidate') {
        if (dto.tag.value[0] === 'checkCandidate-true') {
          const { candidate } = Auth.getProfile()

          this.props.setCandidateId(
            this.state.existingConversation.candidate_id._id,
          )

          await this.setState({
            formData: {
              ...this.state.FormData,
              Prénom: candidate.firstname,
              Nom: candidate.lastname,
              Mail: candidate.email,
            },
            rawVariablesById: {
              ...this.state.rawVariablesById,
              ...this.state.existingConversation.variablesById,
            },
            candidateAuthenticated: true,
            conversationId: this.state.existingConversation._id,
          })

          const lastStepId = this.state.existingConversation.lastStep_id

          if (lastStepId) {
            const stepIndex = this.state.rawSteps
              .map((step) => step._id)
              .indexOf(lastStepId)

            const questionsSteps = this.state.rawSteps.filter(
              (step) => step.type !== 'text',
            )

            const lastQuestionStepId =
              questionsSteps.length > 0
                ? questionsSteps[questionsSteps.length - 1]._id
                : null

            if (stepIndex > 0 && lastStepId !== lastQuestionStepId) {
              await this.setState({
                currentStepIndex: stepIndex >= 0 ? stepIndex : 1,
              })
              addNextSteps(this)
              return success()
            }
            if (stepIndex > 0 && lastStepId === lastQuestionStepId) {
              this.cf.addRobotChatResponse(
                'Vous avez déjà candidaté à cette offre.',
              )
              return success()
            }
            addNextSteps(this)
            return success()
          }
        } else if (dto.tag.value[0] === 'checkCandidate-false') {
          // Auth.logout();
        }
      }

      const { Prénom, Nom, Mail } = this.state.formData

      if (Prénom && Nom && Mail) {
        const handleCandidateCreation = async (password) => {
          const candidate = await Auth.signup(this.props.companyId, {
            firstname: Prénom,
            lastname: Nom,
            email: Mail,
            ...(password ? { atsPassword: password } : {}),
            requiredAtsFields: this.props.requiredAtsFieldsCandidate,
          })

          this.props.setCandidateId(candidate._id)

          this.setState({ candidateAuthenticated: true, candidate })

          const conversation = await Auth.fetch(
            `/lambda-conversation?candidate_id=${candidate._id}&offer_id=${this.state.offerId}`,
            {
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            },
          )

          const { data, total } = conversation

          if (total > 0) {
            const conversationId = data[0]._id

            const patchedConversation = Auth.fetch('/lambda-interaction', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                ...params,
                conversationId,
              }),
            })

            this.setState({
              messagesToSave: [],
              rawVariablesById: {
                ...this.state.rawVariablesById,
                ...patchedConversation.variablesById,
              },
              newRawVariablesById: {},
              conversationId,
            })

            const lastStepId = data[0].lastStep_id

            if (lastStepId) {
              const stepIndex = this.state.rawSteps
                .map((step) => step._id)
                .indexOf(lastStepId)
              const questionsSteps = this.state.rawSteps.filter(
                (step) => step.type !== 'text',
              )

              const lastQuestionStepId =
                questionsSteps.length > 0
                  ? questionsSteps[questionsSteps.length - 1]._id
                  : null

              if (stepIndex > 0 && lastStepId !== lastQuestionStepId) {
                await this.setState({
                  currentStepIndex: stepIndex >= 0 ? stepIndex : 1,
                })
                addNextSteps(this)
                return success()
              }
              if (stepIndex > 0 && lastStepId === lastQuestionStepId) {
                this.cf.addRobotChatResponse(
                  'Vous avez déjà candidaté à cette offre',
                )
                return success()
              }
              addNextSteps(this)
              return success()
            }
            addNextSteps(this)
            return success()
          }

          let talentLike = []
          if (this.state.candidate.talentId) {
            const { data } = await app
              .service('lambda-talent')
              .find({
                query: {
                  type: 'getLike',
                  talentId: this.state.candidate.talentId,
                  offerId: this.state.offerId,
                },
              })
              .then((res) => {
                return Promise.resolve(res)
              })
            talentLike = data.slice()
          }

          const likeCreatedBy = talentLike[0]?.createdBy
          const query = new URLSearchParams(this.props.location.search)
          const source = query.get('source') || 'unknown'

          const postedConversation = await Auth.fetch('/lambda-conversation', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              candidate_id: candidate._id,
              offer_id: this.state.offerId,
              company_id: this.state.companyId,
              team_id: this.state.teamId,
              messages: this.state.messagesToSave,
              variablesById: this.state.newRawVariablesById,
              lastChatbotInteraction: new Date(),
              requiredAtsFields: this.props.requiredAtsFieldsApplication,
              source,
              createdFrom: !this.state.candidate.talentId
                ? 'campaign'
                : likeCreatedBy === 'user'
                ? 'reactivation'
                : 'suggestion',
            }),
          })

          if (postedConversation?.importedFromAts) {
            this.cf.addRobotChatResponse(
              'Vous avez déjà candidaté à cette offre',
            )
            return success()
          }

          this.setState({
            conversationId: postedConversation._id,
            messagesToSave: [],
            newRawVariablesById: {},
          })
          addNextSteps(this)
          success()
        }

        if (this.props.requireCandidatePassword) {
          const res = await Auth.fetch('/candidates', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              company_id: this.props.companyId,
              firstname: Prénom,
              lastname: Nom,
              email: Mail,
              checkExistingAtsCandidate: true,
            }),
          })

          // candidate doesn't exists in ATS so need to ask for password
          if (!res.candidateExists) {
            return await this.createPassword(handleCandidateCreation)
          }
          // candidate exists in ATS so no need to ask for password

          return handleCandidateCreation()
        }

        return handleCandidateCreation()
      }
      // Continue until Prénom, Nom & Mail are given
      addNextSteps(this)
      success()
    } else {
      if (stepId === 'messagingPlatform' && dto.tag.value[0] !== 'mail') {
        return handleMessagingPlatform(dto.tag.value[0], this, success, error)
      }

      if (step.requirement === 'Téléphone' || stepId === 'askPhoneNumber') {
        return handleAddPhoneNumber(dto.text, params, this, success, error)
      }

      if (type === 'file') {
        const { files } = dto.tag.domElement

        const file = files[0]

        if (!checkFileSize(file)) {
          this.toggleError()
          return error()
        }

        const { requirement, attachmentType } = step

        let fileType = 'other'

        // check requirement to support old config
        if (attachmentType === 'resume' || requirement === 'CV') {
          fileType = 'resume'
        }
        if (
          attachmentType === 'coverletter' ||
          requirement === 'Lettre de motivation'
        ) {
          fileType = 'coverletter'
        }

        try {
          const savedFile = await handleFile(
            file,
            step.name,
            fileType,
            stepId,
            conversationId,
          )

          if (!(savedFile.id && savedFile.successfulSave)) {
            throw new Error("L'enregistrement du fichier a échoué")
          }
        } catch (err) {
          this.toggleError()
          if (err.message === 'Received file format is not accepted') {
            return error("Ce format de fichier n'est pas accepté")
          }

          return error(err.message)
        }
      }
      await Auth.fetch('/lambda-interaction', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...params,
          conversationId,
        }),
      })
      this.setState({
        messagesToSave: [],
        newRawVariablesById: {},
      })
      addNextSteps(this)
      success()
    }
  } catch (e) {
    success()
    this.cf.addRobotChatResponse(
      'Une erreur est survenue &#128542;. Revenez dans quelques instants pour finaliser votre candidature !',
    )
    return this.cf.flowManager.stop()
  }
}
